import {
  RtkErrorResponseOfVsApi,
  VsApiError,
  isErrorDataOfVsApi,
} from '@vs/rtk/utils';
import { useTranslation } from 'react-i18next';

import { Row } from '../type';
import { CodeBlock } from './CodeBlock';
import InfoBlock from './InfoBlock';

type PropsVsApiErrorInfo = {
  sentryId?: string;
  errorObj: VsApiError;
  showFullErrMsg?: boolean;
};

export function VsApiErrorInfo({
  sentryId,
  errorObj,
  showFullErrMsg = false,
}: PropsVsApiErrorInfo) {
  const { t } = useTranslation();

  const errorInfo = errorObj.cause;
  const rows = (
    isErrorDataOfVsApi(errorInfo)
      ? [
          {
            label: t('shared:dialog.unexpected_err.label.path', {
              defaultValue: `Path`,
            }),
            value: errorInfo.path,
            hide: !showFullErrMsg,
          },
          {
            label: t('shared:dialog.unexpected_err.label.code', {
              defaultValue: `Code`,
            }),
            value: errorInfo.code,
            hide: !showFullErrMsg,
          },
          {
            label: t('shared:dialog.unexpected_err.label.status_code', {
              defaultValue: `Status code`,
            }),
            value: errorInfo.status_code,
            hide: !showFullErrMsg,
          },
          {
            label: t('shared:dialog.unexpected_err.label.service', {
              defaultValue: `Service`,
            }),
            value: errorInfo.service,
            hide: !showFullErrMsg,
          },
          {
            label: t('shared:dialog.unexpected_err.label.timestamp', {
              defaultValue: `Timestamp`,
            }),
            value: errorInfo.timestamp,
            hide: !showFullErrMsg,
          },
        ]
      : []
  ) satisfies Row[];

  const sentryLogId = `${t('shared:dialog.unexpected_err.label.log_id', {
    defaultValue: `Log ID`,
  })}: ${sentryId}`;
  const requestId = isErrorDataOfVsApi(errorInfo)
    ? `${t('shared:dialog.unexpected_err.label.req_id', {
        defaultValue: `Request ID`,
      })}: ${errorInfo.request_id}`
    : '';
  const errorMessage = isErrorDataOfVsApi(errorInfo)
    ? !showFullErrMsg
      ? undefined
      : typeof errorInfo.message === 'string'
        ? errorInfo.message
        : JSON.stringify(errorInfo.message, null, 2)
    : JSON.stringify(errorInfo?.data);
  return (
    <>
      <CodeBlock className="mb-4" enableCopy>
        {`${sentryLogId}${requestId && `\n${requestId}`}`}
      </CodeBlock>
      <InfoBlock
        rows={rows.filter(r => !r.hide)}
        additionalMessage={errorMessage}
      />
    </>
  );
}
